import { render, staticRenderFns } from "./CategoryButtons.vue?vue&type=template&id=5c5c8d71&scoped=true&"
import script from "./CategoryButtons.vue?vue&type=script&lang=js&"
export * from "./CategoryButtons.vue?vue&type=script&lang=js&"
import style0 from "./CategoryButtons.vue?vue&type=style&index=0&id=5c5c8d71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5c8d71",
  null
  
)

export default component.exports